import * as v from "valibot";
import { rpcContract } from "../rpc";

export const sendLiveChatMessageRpcContract = rpcContract({
  name: "send-live-chat-message",
  paramsSchema: v.object({
    liveEventId: v.string(),
    content: v.pipe(v.string(), v.minLength(1, "Message cannot be empty"), v.maxLength(500, "Message too long")),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    messageId: v.optional(v.string()),
    sentAt: v.optional(v.string()),
  }),
});

export const getLiveChatMessagesRpcContract = rpcContract({
  name: "get-live-chat-messages",
  paramsSchema: v.object({
    liveEventId: v.string(),
    limit: v.optional(v.string()),
  }),
  resultSchema: v.object({
    messages: v.array(
      v.object({
        id: v.string(),
        userId: v.string(),
        userName: v.string(),
        userAvatarUrl: v.nullable(v.string()),
        content: v.string(),
        sentAt: v.string(),
      }),
    ),
  }),
});

export type SendLiveChatMessageParams = v.InferOutput<typeof sendLiveChatMessageRpcContract.paramsSchema>;
export type SendLiveChatMessageResult = v.InferOutput<typeof sendLiveChatMessageRpcContract.resultSchema>;

export type GetLiveChatMessagesParams = v.InferOutput<typeof getLiveChatMessagesRpcContract.paramsSchema>;
export type GetLiveChatMessagesResult = v.InferOutput<typeof getLiveChatMessagesRpcContract.resultSchema>;
